import { faPaperPlane } from '@fortawesome/pro-light-svg-icons/faPaperPlane';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import TwoFourSevenValuationsIcon from '@propertypal/shared/src/resources/icons/agent-advantage/247Valuations_icon.svg';
import AgentAdvantageLogo from '@propertypal/shared/src/resources/icons/agent-advantage/AgentAdvantage_logo.svg';
import AgentAdvantageComparableLogo from '@propertypal/shared/src/resources/icons/agent-advantage/AgentAdvantageComparables_logo.svg';
import AgentAdvantageIntelligenceLogo from '@propertypal/shared/src/resources/icons/agent-advantage/AgentAdvantageIntelligence_logo.svg';
import AgentAdvantageValuationsLogo from '@propertypal/shared/src/resources/icons/agent-advantage/AgentAdvantageValuations_logo.svg';
import AttractNewClients from '@propertypal/shared/src/resources/icons/agent-advantage/AttractNewClients_icon.svg';
import Banner from '@propertypal/shared/src/resources/icons/agent-advantage/banner.svg';
import BoostEfficiencyIcon from '@propertypal/shared/src/resources/icons/agent-advantage/BoostEfficiency_icon.svg';
import CityScape from '@propertypal/shared/src/resources/icons/agent-advantage/city-scape-outlined.svg';
import ClientSatisfactionIcon from '@propertypal/shared/src/resources/icons/agent-advantage/ClientSatisfaction_icon.svg';
import EnhanceDecisionsIcon from '@propertypal/shared/src/resources/icons/agent-advantage/EnhanceDecisions_icon.svg';
import EnquiryProcessIcon from '@propertypal/shared/src/resources/icons/agent-advantage/enquiry-process-icon.svg';
import GrowYourBusinessIcon from '@propertypal/shared/src/resources/icons/agent-advantage/GrowYourBusiness_icon.svg';
import AgentAdvantageInboxLogo from '@propertypal/shared/src/resources/icons/agent-advantage/inbox-pro-logo.svg';
import IntelligenceIpad from '@propertypal/shared/src/resources/icons/agent-advantage/intelligence_ipad.png';
import OrangeArrow from '@propertypal/shared/src/resources/icons/agent-advantage/orange-arrow.svg';
import SaveTimeIcon2 from '@propertypal/shared/src/resources/icons/agent-advantage/save-time-icon.svg';
import SaveTimeIcon from '@propertypal/shared/src/resources/icons/agent-advantage/SaveTime_icon.svg';
import StreamLineIcon from '@propertypal/shared/src/resources/icons/agent-advantage/streamlined-communication-icon.svg';
import StrengthenValuationsIcon from '@propertypal/shared/src/resources/icons/agent-advantage/StrengthenValuations_icon.svg';
import Arrows from '@propertypal/shared/src/resources/icons/agent-advantage/transparent-arrows.svg';
import UnlockInsightsIcon from '@propertypal/shared/src/resources/icons/agent-advantage/UnlockInsights_icon.svg';
import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { validEmail, validPhoneCharacters } from '@propertypal/shared/src/utils/regex';
import Button from '@propertypal/web-ui/src/buttons/Button';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import TextInput from '@propertypal/web-ui/src/inputs/TextInput';
import Recaptcha, { getCaptchaKey } from '@propertypal/web-ui/src/security/Recaptcha';
import { openToast } from '@propertypal/web-ui/src/toast/ToastContext';
import { useFormik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTheme } from 'styled-components';
import * as yup from 'yup';
import {
  Black,
  CircleNumber,
  CityScapeContainer,
  ContactForm,
  ContactsBg,
  ContactWrapper,
  DetailsBg,
  DetailsBox,
  DetailsColumn,
  DetailsLaptop,
  DetailsList,
  DetailsListItem,
  DetailsText,
  DidYouKnow,
  FAQRow,
  FAQs,
  FAQText,
  Header,
  HeaderBg,
  HeaderCircle,
  HeaderImages,
  HeaderTextBox,
  InputRow,
  TopLaptopAnimations,
  TopLaptopImage,
  ListIcon,
  PagerWrapper,
  Primary,
  SummaryBox,
  SummaryItem,
  SummaryRow,
  SummaryText,
  White,
  Wrapper,
  ValuationsAnimation,
  LaptopBanner,
  VideoBox,
  Tabs,
} from './ValuationsSalesPage.style';

const INBOX_PRO_VIDEO_ID = '05f5fc5ac2c7087877361ef83492dbbc';
const COMPARABLES_VIDEO_ID = '4a9f83a26291c80c0808a09af2eb5648';
const INTELLIGENCE_VIDEO_ID = '3cd4078c8aa30388042a28abb1946ff9';

const validationSchema = yup.object().shape({
  name: yup.string().trim().required('Please enter your name'),
  company: yup.string().trim().required('Please enter a company name'),
  email: yup
    .string()
    .matches(validEmail, 'Please enter a valid email address')
    .required('Please enter your email address'),
  phoneNumber: yup
    .string()
    .matches(validPhoneCharacters, 'Please enter a valid phone number')
    .required('Please enter your phone number'),
});

const FAQ_TEXT = [
  {
    title: 'What is Agent Advantage?',
    text: 'Agent Advantage is a comprehensive suite of tools designed to empower agents to manage their property enquiries in one place, enjoy enhanced in-listing branding, create branded comparable reports and unlock intelligence to maximise business growth.',
  },
  {
    title: 'What tools are included in Agent Advantage?',
    text: 'Agent Advantage is a suite of tools that includes Agent Advantage Inbox Pro, Agent Advantage Valuations, Agent Advantage Comparables and Agent Advantage Intelligence.',
  },
  {
    title: 'What is Agent Advantage Inbox Pro?',
    text: "Inbox Pro is the latest software in the Agent Advantage suite of tools. Don't let the influx of property enquiries slow you down, manage all leads from one place ensuring you stay on top of every enquiry quicker and easier than every before.",
  },
  {
    title: 'What is Agent Advantage Valuations?',
    text: "Agent Advantage Valuations is a powerful lead generation tool that features a prominent 'Request a Valuation' button on all of your listings. This ensures you are the top choice for homeowners seeking an agent valuation.",
  },
  {
    title: 'What is Agent Advantage Comparables?',
    text: 'Agent Advantage Comparables provides agents with access to an extensive market wide property database to choose comparable properties and create branded reports for prospective clients.',
  },
  {
    title: 'What is Agent Advantage Intelligence?',
    text: 'Agent Advantage Intelligence provides agents with a dashboard of data on their business performance and actionable insights for strategic decision-making',
  },
  {
    title: 'How can Agent Advantage benefit my business?',
    text: 'Agent Advantage is an all-encompassing solution that offers numerous benefits to agents. By utilising the suite of tools, you can improve your business performance by generating more valuation leads, creating branded comparable reports and accessing valuable data-driven insights to inform strategic decision-making. With this competitive edge, agents can strengthen their position as market leaders in the Northern Ireland property industry.',
  },
  {
    title: 'Can I customise Agent Advantage to fit my business needs?',
    text: [
      <span key="1">
        Agent Advantage is very adaptable and can be customised to meet the unique needs and preferences of your
        business. Our team is always on hand to provide guidance and support. For any questions, simply drop us an email
        at{' '}
      </span>,
      <a key="2" href="mailto:agentadvantage@propertypal.com">
        agentadvantage@propertypal.com
      </a>,
      <span key="3"> and we will be happy to help.</span>,
    ],
  },
  {
    title: 'Is Agent Advantage easy to use?',
    text: [
      <span key="1">
        Agent Advantage has been designed to be simple and user-friendly so you can get started right away without any
        extensive training. Plus, our dedicated team is always here to provide ongoing support and assistance whenever
        you need it. If you ever get stuck, don&apos;t worry - we&apos;ve got you covered with our handy user guides
        that are designed to make everything crystal clear. For any questions, simply drop us an email at{' '}
      </span>,
      <a key="2" href="mailto:agentadvantage@propertypal.com">
        agentadvantage@propertypal.com
      </a>,
      <span key="3"> and we will be happy to help.</span>,
    ],
  },
];

const ValuationsSalesPage = () => {
  const theme = useTheme();
  const contactFormRef = useRef<HTMLFormElement | null>(null);
  const [activeFaq, setActiveFaq] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const toggleFaq = (title: string) => {
    setActiveFaq(activeFaq === title ? '' : title);
  };

  const scrollTo = (target: any) => () => {
    if (target.current) {
      const top = target.current.getBoundingClientRect().top + window.scrollY - 20;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    }
  };

  const handleSubmit = async (values: any) => {
    setLoading(true);

    try {
      const recaptcha = await getCaptchaKey('enquire');

      await axios(
        {
          method: 'POST',
          url: `${API_URL}/agent-enquire`,
          data: {
            name: values.name,
            email: values.email,
            telephone: values.phoneNumber,
            company: values.company,
            comments: 'Enquiry about agent advantage',
            recaptcha,
            reason: 'agentAdvantage',
          },
        },
        dispatch,
      );

      scrollTo(contactFormRef)();
      setSent(true);
    } catch {
      setLoading(false);
      openToast({
        title: 'Error',
        message: "Something went wrong. We couldn't send your enquiry. Please try again!",
        type: 'error',
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      name: '',
      phoneNumber: '',
      company: '',
      email: '',
    },
    validationSchema,
    onSubmit: (values) => {
      if (!loading) {
        handleSubmit(values);
      }
    },
  });

  useEffect(() => {
    if (formik.submitCount > 0 && formik.errors && Object.keys(formik.errors).length > 0) {
      scrollTo(contactFormRef)();
    }
  }, [formik.submitCount, formik.errors]);

  return (
    <PagerWrapper>
      <Recaptcha />

      <Header>
        <HeaderCircle />
        <HeaderBg />

        <Wrapper>
          <HeaderTextBox>
            <AgentAdvantageLogo viewBox="0 0 908 322" />

            <h1>Are you ready to take the lead?</h1>
            <h2>
              Agent Advantage is a suite of tools built exclusively for property professionals in Northern Ireland.
            </h2>
            <h2>
              Manage your property enquiries in one place, enjoy enhanced in-listing branding, build comparable reports
              and discover custom insights on your branch performance.
            </h2>

            <Button containerStyle={{ maxWidth: 320 }} onClick={scrollTo(contactFormRef)}>
              Get Started
            </Button>
          </HeaderTextBox>

          <HeaderImages>
            <img src={IntelligenceIpad.src} alt="valuation ipad" />
            <TopLaptopAnimations>
              <TopLaptopImage />
            </TopLaptopAnimations>
          </HeaderImages>
        </Wrapper>
        <Tabs />
      </Header>

      <SummaryBox>
        <Wrapper style={{ flexDirection: 'column' }}>
          <h2>Gain access to four INCREDIBLE tools…</h2>

          <SummaryRow>
            <SummaryItem>
              <CircleNumber>1</CircleNumber>

              <AgentAdvantageInboxLogo />
            </SummaryItem>

            <SummaryItem>
              <CircleNumber>2</CircleNumber>

              <AgentAdvantageValuationsLogo />
            </SummaryItem>

            <SummaryItem>
              <CircleNumber>3</CircleNumber>

              <AgentAdvantageComparableLogo />
            </SummaryItem>

            <SummaryItem>
              <CircleNumber>4</CircleNumber>

              <AgentAdvantageIntelligenceLogo />
            </SummaryItem>
          </SummaryRow>

          <SummaryText>
            Experience Agent Advantage to gain a competitive edge that boosts your business performance and strengthens
            you as a leader in the Northern Ireland property market. Continue scrolling to explore the amazing benefits
            each tool will bring to your business.
          </SummaryText>

          <Button containerStyle={{ maxWidth: 320, margin: '0 auto' }} onClick={scrollTo(contactFormRef)}>
            Get Started
          </Button>
        </Wrapper>

        <CityScapeContainer>
          <CityScape />
        </CityScapeContainer>
      </SummaryBox>

      {/* AGENT ADVANTAGE INBOX PRO */}
      <DetailsBox id="inboxpro">
        <Wrapper mobileReverse>
          <DetailsColumn align="left" type="list">
            <DetailsBg align="left" color={theme.primary}>
              <Arrows />
            </DetailsBg>

            <CircleNumber color={theme.textDark}>1</CircleNumber>

            <DetailsList align="left" bulletColour={theme.textDark}>
              <h4>
                Make managing enquires a breeze<Black>.</Black>
              </h4>

              <h5>
                <Black>Here&apos;s what you get access to:</Black>
              </h5>

              <ul>
                <li>
                  Manage PropertyPal enquiries from one place. Organise with text search, categories and reply
                  instantly.
                </li>
                <li>
                  Enhance engagement with personalised responses to all or selected enquiries. Tailor responses to
                  specific properties for a personalised touch.
                </li>
                <li>
                  Access a complete history of enquiries made by a single person for improved customer relationship
                  management.
                </li>
                <li>Ensure prompt communication with automatic reply templates.</li>
                <li>Save time with response templates for quick and consistent answers.</li>
                <li>Streamline workflow with grouped property enquiries, ensuring no lead is overlooked.</li>
              </ul>

              <h5>
                <Black>What does this mean for your business?</Black>
              </h5>

              <DetailsListItem>
                <ListIcon>
                  <SaveTimeIcon2 viewBox="0 0 40 50" />
                </ListIcon>

                <p>Save Time</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <EnquiryProcessIcon viewBox="0 0 49 45" />
                </ListIcon>

                <p>Simplified Enquiry Process</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <StreamLineIcon viewBox="0 0 47 45" />
                </ListIcon>

                <p>Streamlined Communication</p>
              </DetailsListItem>
            </DetailsList>
          </DetailsColumn>

          <DetailsColumn align="right" type="details">
            <AgentAdvantageInboxLogo />

            <DetailsText>
              <b>Inbox Pro</b> is the latest powerhouse in our Agent Advantage suite of tools. Don&apos;t let the influx
              of property enquiries slow you down, manage all leads from one place ensuring you stay on top of every
              enquiry quicker and easier than ever before.
            </DetailsText>

            <DetailsLaptop>
              {/* <InboxProAnimation /> */}
              <VideoBox>
                <iframe
                  title="agent advantage inbox pro"
                  // eslint-disable-next-line
                  src={`https://customer-bt5u95z8iqneaihl.cloudflarestream.com/${INBOX_PRO_VIDEO_ID}/iframe?poster=https%3A%2F%2Fcustomer-bt5u95z8iqneaihl.cloudflarestream.com%2F${INBOX_PRO_VIDEO_ID}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2.6s%26height%3D600`}
                  style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                  allowFullScreen
                />
              </VideoBox>

              <LaptopBanner>
                <Banner />
                <p>NEW PRODUCT</p>
              </LaptopBanner>
            </DetailsLaptop>

            <h3>
              Empowering agents, accelerating success<Primary>.</Primary>
            </h3>

            <Button containerStyle={{ maxWidth: 320 }} onClick={scrollTo(contactFormRef)}>
              Get Started
            </Button>
          </DetailsColumn>
        </Wrapper>
      </DetailsBox>

      {/* AGENT ADVANTAGE VALUATIONS */}
      <DetailsBox id="valuations">
        <Wrapper>
          <DetailsColumn align="left" type="details">
            <AgentAdvantageValuationsLogo />

            <DetailsText>
              Maximise the impact of your property listings with <b>Agent Advantage Valuations</b>. With a footfall of
              over 1.3m active users monthly on PropertyPal, claim the spotlight with enhanced agency branding and a
              prominent valuations lead button integrated onto each of your property listings.
            </DetailsText>

            <DetailsLaptop>
              <ValuationsAnimation />
            </DetailsLaptop>

            <h3>
              Empowering agents, accelerating success<Primary>.</Primary>
            </h3>

            <Button containerStyle={{ maxWidth: 320 }} onClick={scrollTo(contactFormRef)}>
              Get Started
            </Button>
          </DetailsColumn>

          <DetailsColumn align="right" type="list">
            <DetailsBg align="right" color="#FFB494">
              <Arrows />
            </DetailsBg>

            <CircleNumber color={theme.textDark}>2</CircleNumber>

            <DetailsList align="right" bulletColour={theme.textDark}>
              <h4>
                <Black>
                  Open the door to more valuations<Primary>.</Primary>
                </Black>
              </h4>

              <h5>Here&apos;s what you get access to:</h5>

              <ul>
                <li>Enhanced agency branding across all of your property listings</li>
                <li>
                  Exclusive <b>&apos;Request a Valuation&apos;</b> button displayed across all of your property listings
                </li>
                <li>Enhanced valuation leads around the clock</li>

                <DidYouKnow>
                  <b>Did you know?</b> The majority of leads are outside office hours.
                  <OrangeArrow />
                </DidYouKnow>
              </ul>

              <h5>What does this mean for you business?</h5>

              <DetailsListItem>
                <ListIcon>
                  <AttractNewClients viewBox="0 0 54 60" />
                </ListIcon>

                <p>Boosted Brand Visibility</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <TwoFourSevenValuationsIcon viewBox="0 0 55 60" />
                </ListIcon>

                <p>Valuation Leads 24/7</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <GrowYourBusinessIcon viewBox="0 0 60 60" />
                </ListIcon>

                <p>Consistent Flow of New Clients</p>
              </DetailsListItem>
            </DetailsList>
          </DetailsColumn>
        </Wrapper>
      </DetailsBox>

      {/* AGENT ADVANTAGE COMPARABLES */}
      <DetailsBox id="comparables">
        <Wrapper mobileReverse>
          <DetailsColumn align="left" type="list">
            <DetailsBg align="left" color={theme.textLight}>
              <Arrows />
            </DetailsBg>

            <CircleNumber>3</CircleNumber>

            <DetailsList align="left">
              <h4>
                <Primary>
                  Comparative data at your fingertips<White>.</White>
                </Primary>
              </h4>

              <h5>Here&apos;s what you get access to:</h5>

              <ul>
                <li>Archive of historical property adverts</li>
                <li>Advanced comparable search capabilities</li>
                <li>Draw a search option to refine results</li>
                <li>Manual comparables for unlisted properties</li>
                <li>Showcase recently sold properties</li>
                <li>Download and email report functionality</li>
              </ul>

              <h5>What does this mean for your business?</h5>

              <DetailsListItem>
                <ListIcon>
                  <StrengthenValuationsIcon viewBox="0 0 65 60" />
                </ListIcon>

                <p>Unmatched Insights</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <SaveTimeIcon viewBox="0 0 56 60" />
                </ListIcon>

                <p>Strengthened Valuations</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <ClientSatisfactionIcon viewBox="0 0 58 61" />
                </ListIcon>

                <p>Enhanced Expertise</p>
              </DetailsListItem>
            </DetailsList>
          </DetailsColumn>

          <DetailsColumn align="right" type="details">
            <AgentAdvantageComparableLogo />

            <DetailsText>
              Gain access to a comprehensive market wide property database with <b>Agent Advantage Comparables</b>.
              Create branded reports in minutes that enhance your valuations and impress potential clients.
            </DetailsText>

            <DetailsLaptop>
              {/* <ComparablesAnimation /> */}
              <VideoBox>
                <iframe
                  title="agent advantage comparables"
                  // eslint-disable-next-line
                  src={`https://customer-bt5u95z8iqneaihl.cloudflarestream.com/${COMPARABLES_VIDEO_ID}/iframe?poster=https%3A%2F%2Fcustomer-bt5u95z8iqneaihl.cloudflarestream.com%2F${COMPARABLES_VIDEO_ID}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2.6s%26height%3D600`}
                  style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                  allowFullScreen
                />
              </VideoBox>
            </DetailsLaptop>

            <h3>
              Empowering agents, accelerating success<Primary>.</Primary>
            </h3>

            <Button containerStyle={{ maxWidth: 320 }} onClick={scrollTo(contactFormRef)}>
              Get Started
            </Button>
          </DetailsColumn>
        </Wrapper>
      </DetailsBox>

      {/* AGENT ADVANTAGE INTELLIGENCE */}
      <DetailsBox id="intelligence">
        <Wrapper>
          <DetailsColumn align="left" type="details">
            <AgentAdvantageIntelligenceLogo />

            <DetailsText>
              Discover enhanced data on your branch performance including comprehensive market share insights. With{' '}
              <b>Agent Advantage Intelligence</b>, <b>utilise</b> the power of data to <b>gain</b> actionable insights
              and drive your business forward.
            </DetailsText>

            <DetailsLaptop>
              {/* <IntelligenceAnimation /> */}
              <VideoBox>
                <iframe
                  title="agent advantage intelligence"
                  // eslint-disable-next-line
                  src={`https://customer-bt5u95z8iqneaihl.cloudflarestream.com/${INTELLIGENCE_VIDEO_ID}/iframe?poster=https%3A%2F%2Fcustomer-bt5u95z8iqneaihl.cloudflarestream.com%2F${INTELLIGENCE_VIDEO_ID}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D2.6s%26height%3D600`}
                  style={{ border: 'none', position: 'absolute', top: 0, left: 0, height: '100%', width: '100%' }}
                  allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
                  allowFullScreen
                />
              </VideoBox>
            </DetailsLaptop>

            <h3>
              Empowering agents, accelerating success<Primary>.</Primary>
            </h3>

            <Button containerStyle={{ maxWidth: 320 }} onClick={scrollTo(contactFormRef)}>
              Get Started
            </Button>
          </DetailsColumn>

          <DetailsColumn align="right" type="list">
            <DetailsBg align="right" color={theme.primary}>
              <Arrows />
            </DetailsBg>

            <CircleNumber color={theme.textDark}>4</CircleNumber>

            <DetailsList align="right" bulletColour={theme.textDark}>
              <h4>
                <White>
                  Data-driven insight for strategic decisions<Black>.</Black>
                </White>
              </h4>

              <h5>Here&apos;s what you get access to:</h5>

              <ul>
                <li>Performance trends across key business metrics including comprehensive market share insights</li>
                <li>Flexible customisation to compare over time and location</li>
                <li>Track bespoke performance metrics by property types and price ranges</li>
                <li>Advanced data visualisation and reporting functionality</li>
              </ul>

              <h5>What does this mean for your business?</h5>

              <DetailsListItem>
                <ListIcon>
                  <UnlockInsightsIcon viewBox="0 0 60 60" />
                </ListIcon>

                <p>In-depth Insights</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <BoostEfficiencyIcon viewBox="0 0 68 62" />
                </ListIcon>

                <p>Precise Performance Monitoring</p>
              </DetailsListItem>

              <DetailsListItem>
                <ListIcon>
                  <EnhanceDecisionsIcon viewBox="0 0 61 60" />
                </ListIcon>

                <p>Enhanced Decision Making</p>
              </DetailsListItem>
            </DetailsList>
          </DetailsColumn>
        </Wrapper>
      </DetailsBox>

      <ContactWrapper>
        <ContactsBg />

        <Wrapper style={{ alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <AgentAdvantageLogo
              viewBox="0 0 908 322"
              style={{ width: 280, height: 100, marginTop: 60, marginLeft: -15 }}
            />

            <h2>
              Empowering agents, accelerating success<Primary>.</Primary>
            </h2>
          </div>

          <ContactForm onSubmit={formik.handleSubmit} ref={contactFormRef} id="contactForm">
            {!sent && (
              <>
                <h3>Find out more about Agent Advantage</h3>

                <InputRow>
                  <TextInput
                    placeholder="Name"
                    name="name"
                    value={formik.values.name}
                    onValueChange={formik.handleChange('name')}
                    error={formik.touched.name && formik.errors.name}
                  />

                  <TextInput
                    placeholder="Company"
                    name="company"
                    value={formik.values.company}
                    onValueChange={formik.handleChange('company')}
                    error={formik.touched.company && formik.errors.company}
                  />
                </InputRow>

                <InputRow>
                  <TextInput
                    placeholder="Email"
                    name="email"
                    value={formik.values.email}
                    onValueChange={formik.handleChange('email')}
                    error={formik.touched.email && formik.errors.email}
                  />

                  <TextInput
                    placeholder="Phone"
                    name="phone"
                    value={formik.values.phoneNumber}
                    onValueChange={formik.handleChange('phoneNumber')}
                    error={formik.touched.phoneNumber && formik.errors.phoneNumber}
                  />
                </InputRow>

                <Button containerStyle={{ marginTop: 30 }} loading={loading} type="submit">
                  Find out More
                </Button>
              </>
            )}

            {sent && (
              <>
                <FontAwesomeIcon
                  icon={faPaperPlane}
                  style={{ margin: '0 auto 30px', fontSize: 50, display: 'block' }}
                  color={theme.textDark}
                />

                <h3>Your message has been sent.</h3>

                <h3>A member of our team will be in touch as soon as possible.</h3>
              </>
            )}
          </ContactForm>
        </Wrapper>
      </ContactWrapper>

      <FAQs>
        <Wrapper style={{ flexDirection: 'column' }}>
          <h2>Most Frequently Asked Questions</h2>

          {FAQ_TEXT.map((faq) => (
            <FAQRow key={faq.title} active={activeFaq === faq.title}>
              <button onClick={() => toggleFaq(faq.title)} type="button">
                {faq.title}
                <FontAwesomeIcon icon={faPlus} color={theme.primary} style={{ fontSize: 24 }} />
              </button>

              <FAQText>
                <p>{faq.text}</p>
              </FAQText>
            </FAQRow>
          ))}
        </Wrapper>
      </FAQs>
    </PagerWrapper>
  );
};

export default ValuationsSalesPage;
